import { render } from "./PontajProiecte.vue?vue&type=template&id=21102dd2&scoped=true&ts=true"
import script from "./PontajProiecte.vue?vue&type=script&lang=ts"
export * from "./PontajProiecte.vue?vue&type=script&lang=ts"

import "./PontajProiecte.vue?vue&type=style&index=0&id=21102dd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21102dd2"]])

export default __exports__